<div class="ticket-list-container">

  <!-- Stats row — admin only -->
  <div class="row mb-4" *ngIf="role === 'admin' && stats">
    <div class="col-6 col-md-4 col-lg mb-2">
      <nb-card status="warning" class="stat-card">
        <nb-card-body>
          <div class="stat-value">{{ stats.open || 0 }}</div>
          <div class="stat-label">Open</div>
        </nb-card-body>
      </nb-card>
    </div>
    <div class="col-6 col-md-4 col-lg mb-2">
      <nb-card status="primary" class="stat-card">
        <nb-card-body>
          <div class="stat-value">{{ stats.in_progress || 0 }}</div>
          <div class="stat-label">In Progress</div>
        </nb-card-body>
      </nb-card>
    </div>
    <div class="col-6 col-md-4 col-lg mb-2">
      <nb-card status="success" class="stat-card">
        <nb-card-body>
          <div class="stat-value">{{ stats.resolved || 0 }}</div>
          <div class="stat-label">Resolved</div>
        </nb-card-body>
      </nb-card>
    </div>
    <div class="col-6 col-md-4 col-lg mb-2">
      <nb-card status="basic" class="stat-card">
        <nb-card-body>
          <div class="stat-value">{{ stats.closed || 0 }}</div>
          <div class="stat-label">Closed</div>
        </nb-card-body>
      </nb-card>
    </div>
    <div class="col-6 col-md-4 col-lg mb-2">
      <nb-card status="info" class="stat-card">
        <nb-card-body>
          <div class="stat-value">{{ stats.total || 0 }}</div>
          <div class="stat-label">Total</div>
        </nb-card-body>
      </nb-card>
    </div>
  </div>

  <!-- Action bar -->
  <div class="row mb-3 align-items-center">
    <div class="col-12 col-md-8">
      <!-- Filters — admin only -->
      <div class="d-flex flex-wrap gap-2" *ngIf="role === 'admin'">
        <nb-select placeholder="All Statuses" [(ngModel)]="statusFilter" (selectedChange)="onFilterChange()" size="small">
          <nb-option value="">All Statuses</nb-option>
          <nb-option value="open">Open</nb-option>
          <nb-option value="in_progress">In Progress</nb-option>
          <nb-option value="resolved">Resolved</nb-option>
          <nb-option value="closed">Closed</nb-option>
        </nb-select>

        <nb-select placeholder="All Priorities" [(ngModel)]="priorityFilter" (selectedChange)="onFilterChange()" size="small">
          <nb-option value="">All Priorities</nb-option>
          <nb-option value="low">Low</nb-option>
          <nb-option value="normal">Normal</nb-option>
          <nb-option value="high">High</nb-option>
          <nb-option value="urgent">Urgent</nb-option>
        </nb-select>

        <nb-select placeholder="All Categories" [(ngModel)]="categoryFilter" (selectedChange)="onFilterChange()" size="small">
          <nb-option value="">All Categories</nb-option>
          <nb-option value="general">General</nb-option>
          <nb-option value="technical">Technical</nb-option>
          <nb-option value="billing">Billing</nb-option>
          <nb-option value="account">Account</nb-option>
        </nb-select>

        <input
          nbInput
          fieldSize="small"
          placeholder="Search tickets..."
          [(ngModel)]="searchQuery"
          (ngModelChange)="onSearchChange()"
          style="width: 200px;"
        />
      </div>
    </div>
    <div class="col-12 col-md-4 text-md-end mt-2 mt-md-0" *ngIf="role !== 'admin'">
      <button nbButton status="primary" size="small" (click)="createTicket()">
        <nb-icon icon="plus-outline"></nb-icon> New Ticket
      </button>
    </div>
  </div>

  <!-- Tickets table -->
  <nb-card>
    <nb-card-body>
      <div *ngIf="loading" class="text-center py-4">
        <p>Loading tickets...</p>
      </div>

      <div *ngIf="!loading && tickets.length === 0" class="text-center py-4">
        <nb-icon icon="message-circle-outline" style="font-size: 2rem; color: #c5cee0;"></nb-icon>
        <p class="mt-2 text-muted">No tickets found.</p>
        <button nbButton status="primary" size="small" (click)="createTicket()" *ngIf="role !== 'admin'">
          Create your first ticket
        </button>
      </div>

      <table class="table text-center" *ngIf="!loading && tickets.length > 0">
        <thead>
          <tr>
            <th>Ticket #</th>
            <th>Subject</th>
            <th>Category</th>
            <th>Priority</th>
            <th>Status</th>
            <th>Assigned To</th>
            <th *ngIf="role === 'admin'">Creator</th>
            <th>Date</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let ticket of tickets | paginate: { id: 'ticket-list-pager', itemsPerPage: itemsPerPage, currentPage: currentPage, totalItems: totalCount }">
            <td><small class="text-muted">#{{ ticket.ticketNumber || ticket._id?.slice(-6) }}</small></td>
            <td class="text-start" style="max-width: 200px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
              {{ ticket.subject }}
            </td>
            <td>
              <span class="text-capitalize">{{ ticket.category || '—' }}</span>
            </td>
            <td>
              <nb-badge [text]="ticket.priority | titlecase" [status]="getPriorityColor(ticket.priority)" position="top right" style="position: static; display: inline-block;"></nb-badge>
            </td>
            <td>
              <nb-badge [text]="formatStatus(ticket.status)" [status]="getStatusColor(ticket.status)" position="top right" style="position: static; display: inline-block;"></nb-badge>
            </td>
            <td>{{ ticket.assignedTo?.name || ticket.assignedTo || '—' }}</td>
            <td *ngIf="role === 'admin'">{{ ticket.createdBy?.name || ticket.createdBy || '—' }}</td>
            <td>{{ ticket.createdAt | date:'dd/MM/yy HH:mm' }}</td>
            <td>
              <button nbButton size="tiny" status="info" (click)="viewTicket(ticket._id)">
                View
              </button>
            </td>
          </tr>
        </tbody>
      </table>

      <div class="d-flex justify-content-center mt-3" *ngIf="totalCount > itemsPerPage">
        <pagination-controls
          id="ticket-list-pager"
          (pageChange)="onPageChange($event)"
          previousLabel="Prev"
          nextLabel="Next">
        </pagination-controls>
      </div>
    </nb-card-body>
  </nb-card>
</div>
